module.exports = __webpack_public_path__ + "static/media/calender.f61b5b46.svg";